import React , { Component } from 'react'
import { ListItem } from 'material-ui/List'
import { toJS } from 'immutable'
import FlatButton from 'material-ui/FlatButton';
import TextField from 'material-ui/TextField';
import _ from 'lodash'


import {Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn} from 'material-ui/Table';

const styles = {
    tbodytop: {
        overflowX: 'scroll'
    },
    tbody: {
        overflow: 'inital',
        overflowX: 'scroll !important'
    },
    turnRed: {
        color: '#FF6600'
    }
}


class RoomItem extends Component {

  constructor(props, context) {
    super(props, context)
    this.addPreference = this.addPreference.bind(this)

    this.removePreference = this.removePreference.bind(this)
    this.state = {editingRanking: false}
    this.editRanking = this.editRanking.bind(this)
    this.saveRanking = this.saveRanking.bind(this)
    this.stopEditingRanking = this.stopEditingRanking.bind(this)
    this.onKeyUp = this.onKeyUp.bind(this)

  }

  shouldComponentUpdate(nextProps, nextState) {
    return nextProps.room !== this.props.room ||
      nextState.editingRanking !== this.state.editingRanking ||
      nextProps.disableLeaderActionButton !== this.props.disableLeaderActionButton ||
      nextProps.renderWithLeaderAction !== this.props.renderWithLeaderAction
  }

  editRanking() {
    this.setState({editingRanking: true})
  }

  saveRanking(event) {
    if (this.state.editingRanking) {
      const room = this.props.room
      const confirmedGroup = this.props.confirmedGroup
      const numPreferences = confirmedGroup.preferences.size

      let newRank = event.target.value.trim()

      const indexToRemove = confirmedGroup.preferences.indexOf(room)
      const nextPreferences = confirmedGroup.preferences.delete(indexToRemove)


      if (newRank < 1) {
        newRank = 1
      }
      else if (newRank > numPreferences) {
        newRank = numPreferences
      }

      const nextPreferencesObj = nextPreferences.splice(newRank - 1, 0, room).toJS()


      this.props.onRoomClick(confirmedGroup, {preferences: nextPreferencesObj})
      this.props.preferenceRankChange()
      this.stopEditingRanking()
    }
  }

  stopEditingRanking() {
    this.setState({editingRanking: false})
  }

  onKeyUp(event) {
    if (event.keyCode === 13) {
      this.saveRanking(event);
    }
    else if (event.keyCode === 27) {
      this.stopEditingRanking();
    }
  }

  renderRanking(rank) {
    if (this.props.renderWithLeaderAction && !this.props.disableLeaderActionButton) {
      return (
        <div
          ref={c => this.rankValue = c}
          onTouchTap={this.editRanking}
          >{rank}</div>
      )
    } else
    {
      return (
        <div>{rank}</div>
      )
    }

  }

  renderRankingInput(rank) {
    return (
      <TextField
        autoComplete="off"
        autoFocus
        defaultValue={rank}
        maxLength="64"
        onBlur={this.saveRanking}
        onKeyUp={this.onKeyUp}
        ref={c => this.rankInput = c}
        type="number"
      />
    );
  }


  addPreference() {
    const room = this.props.room
    const roomObj = room.toJS()
    const confirmedGroup = this.props.confirmedGroup
    delete roomObj.isAllocated
    const doesPrefExist = confirmedGroup.preferences.find((roomObjSearch) => _.isEqual(roomObjSearch,roomObj))

    if (doesPrefExist) {
      this.props.preferenceAlreadyAdded()
    } else {
      if(confirmedGroup.groupSize !== roomObj.capacity) {
        this.props.preferenceGroupSizeMismatch()
      } else {
        const nextPreferencesObj = confirmedGroup.preferences.push(roomObj).toJS()

        this.props.onRoomClick(confirmedGroup, {preferences: nextPreferencesObj})
      }
    }

  }

  removePreference() {
    const room = this.props.room
    const confirmedGroup = this.props.confirmedGroup
    const indexToRemove = confirmedGroup.preferences.indexOf(room)
    const nextPreferencesObj = confirmedGroup.preferences.delete(indexToRemove).toJS()


    this.props.onRoomClick(confirmedGroup, {preferences: nextPreferencesObj})
  }


  render() {
    const { room } = this.props
    if (this.props.isPreferenceItem) {
      const removePreferenceButton = <FlatButton label="Remove" secondary={true} onTouchTap={this.removePreference} disabled={this.props.disableLeaderActionButton}/>
      return (
        <TableRow>
          <TableRowColumn>{room.building}</TableRowColumn>
          <TableRowColumn>{room.unit}</TableRowColumn>
          <TableRowColumn>{room.capacity}</TableRowColumn>
          <TableRowColumn style={styles.turnRed}>{ room.femaleOnly === true ? 'Female Groups Only' : room.maleOnly === true ? "Male Groups Only" : "No Restrictions"}</TableRowColumn>
          <TableRowColumn>{room.isAllocated === true ? 'Unavailable' : 'Available' }</TableRowColumn>
          <TableRowColumn>{this.state.editingRanking ? this.renderRankingInput(this.props.rank) : this.renderRanking(this.props.rank)}</TableRowColumn>
          {this.props.renderWithLeaderAction ? <TableRowColumn>{removePreferenceButton}</TableRowColumn> : null}
        </TableRow>
      )
    } else {
      const genderMismatch = (this.props.currentUserGender === "F" && room.maleOnly || this.props.currentUserGender === "M" && room.femaleOnly  )
      const addPreferenceButton =  <FlatButton label="Select" primary={true} onTouchTap={this.addPreference} disabled={this.props.disableLeaderActionButton || this.props.room.isAllocated || genderMismatch}/>
      return (
        <TableRow style={styles.tbodytop}>
          <TableRowColumn style={styles.tbody}>{room.building}</TableRowColumn>
          <TableRowColumn style={styles.tbody}>{room.unit}</TableRowColumn>
          <TableRowColumn style={styles.tbody}>{room.capacity}</TableRowColumn>
          <TableRowColumn style={styles.turnRed}>{ room.femaleOnly === true ? 'Female Groups Only' : room.maleOnly === true ? "Male Groups Only" : "No Restrictions"}</TableRowColumn>
          <TableRowColumn style={styles.tbody}>{room.isAllocated === true ? 'Unavailable' : 'Available'}</TableRowColumn>
          {this.props.renderWithLeaderAction ? <TableRowColumn style={styles.tbody}>{addPreferenceButton}</TableRowColumn>: null}
        </TableRow>
      )
    }


  }
}

export default RoomItem



// WEBPACK FOOTER //
// ./src/views/components/room-item/index.js